export const environment = {production: true,
    apiPrefix: '',
    test: false,
    ...JSON.parse(localStorage.getItem('environment'))};
